import React, { useState, useEffect, useRef } from 'react';
import Helmet from 'react-helmet';
import Axios from 'axios';

import ProjectCard from '../../components/ProjectCard';
import ImageCarousel from '../../components/ImageCarousel';
import DetailPageLayout from '../../components/DetailPageLayout';

import { getSlugByPathname } from '../../utils/methods';
import SNSPanel from '../../components/SNSPanel';
import Link from '../../components/Link';
import Lightbox from '../../components/ImageCarousel/Lightbox';

import './index.scss';

const ProjectPage = ({ wording }) => {
  const [article, setArticle] = useState(null);
  const [related, setRelated] = useState(null);
  const [lightboxImg, setLightboxImg] = useState(null);

  useEffect(() => {
    const slug = getSlugByPathname('project');
    getProjectContent(slug);
    getRelatedProject(slug);

    return () => {
      delete window.projectPrevScrollpos;
    };
  }, []);



  const getProjectContent = (slug) => {
    Axios.get(`/api/project-page/${slug}`)
      .then(res => setArticle(res.data));
  };

  const getRelatedProject = (slug) => {
    Axios.get(`/api/project-related/${slug}`)
      .then(res => setRelated(res.data));
  };

  const _w = wording;

  if (!article) return null;

  return (
    <React.Fragment>
      <Helmet>
        {
          article &&
          <title>{_w.meta_head + article.title}</title>
        }
      </Helmet>
      {lightboxImg && <Lightbox image={lightboxImg} onClose={() => setLightboxImg(null)} />}
      <DetailPageLayout backLink="/project" className="project-page">
        <SNSPanel />
        <div className="project-cover">
          <img className="image js-banner" src={`/${article.photo}`} alt="" />
        </div>
        <Link to="/contact" className="contact-button">
          <img src="/images/project-contact-icon.svg" alt="" />
          <span className="type-text -en -md">CONTACT US</span>
        </Link>
        <div className="project-info">
          <div className="container">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <div className="info">
                  <h1 className="title type-heading -ch h1">{article.title}</h1>
                  <div className="list dashed-table">
                    <div className="item">
                      <div className="label type-text -en -lg">PROJECT</div>
                      <div className="content type-text -en -lg">{article.title}</div>
                    </div>
                    <div className="item">
                      <div className="label type-text -en -lg">CATEGORY</div>
                      <div className="content type-text -en -lg">{article.category.name}</div>
                    </div>
                    {article.info && JSON.parse(article.info).map((item, i) => (
                      <div className="item" key={i}>
                        {item.name && <div className="label type-text -en -lg">{item.name}</div>}
                        {item.value && <div className="content type-text -en -lg">{item.value}</div>}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="project-article container">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="article">
                {
                  JSON.parse(article.content).map((item, i) =>
                    <React.Fragment key={i}>
                      {
                        item.type === 'image' &&
                        <div className={`row-image ${item.class}`}>
                          {item.src.map((src, j) => <div className="item" key={j} onClick={() => setLightboxImg(src)}>
                            <div className="image lazy" data-lazy={`/${src}`}><img alt="" /></div>
                          </div>)}
                        </div>
                      }
                      {
                        item.type === 'text' &&
                        <div className={`row-text ${item.align} type-text -en -lg`}
                          dangerouslySetInnerHTML={{ __html: item.content }}>
                        </div>
                      }
                    </React.Fragment>
                  )
                }
              </div>
            </div>
          </div>
        </div>
        <div className="project-photos">
          {
            (article && JSON.parse(article.photos) !== "") &&
            <ImageCarousel className="photo-carousel" data={JSON.parse(article.photos)} />
          }
        </div>
        <div className="container">
          <div className="project-more">
            <div className="title type-heading -en -h4">{_w.more}</div>
            <div className="project-grid row">
              {
                related && related.map((item, i) => (
                  <div className="item col-md-4 col-sm-12" key={i}>
                    <ProjectCard
                      photo={`/${item.photo}`}
                      project={item.title}
                      category={item.category.name}
                      clients={item.client}
                      link={`/project/${item.slug}`} />
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </DetailPageLayout>
    </React.Fragment>
  )
}

export default ProjectPage;